var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 70C54.3299 70 69.9999 54.3299 69.9999 35C69.9999 15.6701 54.3299 0 34.9999 0C15.67 0 0 15.6701 0 35C0 54.3299 15.67 70 34.9999 70Z",
    fill: "#004077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3813 32.0463C34.4539 31.0737 38.5387 26.0406 38.5387 20.0472C38.5387 18.5519 41.4929 18.3452 42.2709 21.117C43.1462 24.2413 41.736 26.9767 40.6662 29.6391H45.9909",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0022 29.6392C47.1814 29.6392 48.1297 30.5996 48.1297 31.7666C48.1297 32.9459 47.1693 33.8941 46.0022 33.8941H45.4673",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4675 33.894C46.6468 33.894 47.595 34.8544 47.595 36.0215C47.595 37.2007 46.6346 38.149 45.4675 38.149H44.9326",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4094 38.1609C45.5886 38.1609 46.5369 39.1213 46.5369 40.2884C46.5369 41.4676 45.5765 42.4158 44.4094 42.4158H43.8745",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4673 33.894C46.6465 33.894 47.5948 34.8544 47.5948 36.0215C47.5948 37.2007 46.6344 38.149 45.4673 38.149H44.3975",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8747 46.1606H36.4225C34.2828 46.1606 30.3926 44.2034 30.3926 44.2034",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3411 42.4282H43.6085C44.6418 42.4282 45.4685 43.2671 45.4685 44.2883C45.4685 45.3216 44.6297 46.1483 43.6085 46.1483H42.8062",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8884 44.5557C28.1838 44.5557 28.4233 44.3162 28.4233 44.0208C28.4233 43.7254 28.1838 43.4858 27.8884 43.4858C27.593 43.4858 27.3535 43.7254 27.3535 44.0208C27.3535 44.3162 27.593 44.5557 27.8884 44.5557Z",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1653 29.6147H23.0868C22.4154 29.6147 21.8711 30.159 21.8711 30.8304V45.4188C21.8711 46.0902 22.4154 46.6345 23.0868 46.6345H29.1653C29.8367 46.6345 30.381 46.0902 30.381 45.4188V30.8304C30.381 30.159 29.8367 29.6147 29.1653 29.6147Z",
    stroke: "white",
    strokeWidth: 1.66551,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon1);
export default __webpack_public_path__ + "static/media/home-icon-1.4a13562d085225cf2eea2b8455bc0090.svg";
export { ForwardRef as ReactComponent };